import ECheckTableMobile from './ECheckTableMobile';

export default ECheckTableMobile;
